







import Vue from 'vue'
import XContainer from '@/components/atoms/Container/XContainer.vue'
import StoreOwnerList from '@/components/molecules/StoreOwners/List/StoreOwnerList.vue'

import { Member } from '@/types/generated/graphql'

export default Vue.extend({
  components: { XContainer, StoreOwnerList },
  data() {
    return {
      partnerId: this.$route.params.partnerId,
    }
  },
  methods: {
    onClickDetail(member: Member) {
      this.$router.push({
        name: 'PartnerStoreOwnerDetail',
        params: { partnerId: this.partnerId, userId: member.userId },
      })
    },
  },
})
